import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Person } from './user';

const initialState: Person = {
  firstName: '',
  lastName: '',
  jobTitle: '',
  email: '',
  businessPhone: '',
  extension: '',
  cellPhone: '',
};

export const authorizedOfficerSlice = createSlice({
  name: 'authorizedOfficer',

  initialState,

  reducers: {
    setAuthorizedOfficer(state, action: PayloadAction<Person>) {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.jobTitle = action.payload.jobTitle;
      state.email = action.payload.email;
      state.businessPhone = action.payload.businessPhone;
      state.extension = action.payload.extension;
      state.cellPhone = action.payload.cellPhone;
    },
  },
});

export const authorizedOfficerActions = authorizedOfficerSlice.actions;
export type AuthorizedOfficerSlice = {
  [authorizedOfficerSlice.name]: ReturnType<typeof authorizedOfficerSlice['reducer']>
};
